var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_399_3976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.83673 3.75V16.25C1.83673 16.5938 2.11224 16.875 2.44898 16.875H14.6939C15.0306 16.875 15.3061 16.5938 15.3061 16.25V6.66016C15.3061 6.49609 15.2411 6.33594 15.1263 6.21875L16.4235 4.89453C16.8827 5.36328 17.139 6 17.139 6.66406V16.25C17.139 17.6289 16.0408 18.75 14.6901 18.75H2.44898C1.09821 18.75 0 17.6289 0 16.25V3.75C0 2.37109 1.09821 1.25 2.44898 1.25H11.8431C12.4936 1.25 13.1173 1.51172 13.5765 1.98047L16.4273 4.89062L15.1301 6.21484L12.2755 3.30859C12.264 3.29687 12.2564 3.28906 12.2449 3.27734V7.1875C12.2449 7.70703 11.8355 8.125 11.3265 8.125H3.97959C3.47066 8.125 3.06122 7.70703 3.06122 7.1875V3.125H2.44898C2.11224 3.125 1.83673 3.40625 1.83673 3.75ZM4.89796 3.125V6.25H10.4082V3.125H4.89796ZM6.12245 12.5C6.12245 11.837 6.38047 11.2011 6.83974 10.7322C7.29901 10.2634 7.92192 10 8.57143 10C9.22094 10 9.84385 10.2634 10.3031 10.7322C10.7624 11.2011 11.0204 11.837 11.0204 12.5C11.0204 13.163 10.7624 13.7989 10.3031 14.2678C9.84385 14.7366 9.22094 15 8.57143 15C7.92192 15 7.29901 14.7366 6.83974 14.2678C6.38047 13.7989 6.12245 13.163 6.12245 12.5Z",
    fill: "#43BBC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_399_3976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1429,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.f029ded098ca319218f3cd6fd3b50456.svg";
export { ForwardRef as ReactComponent };